import { get } from 'lodash';

const styles = ({ margin, padding }) => ({
  fieldContainer: {
    padding: `0px ${get(padding, 'p10')}`,
    margin: '0 !important',
  },
  addBtn: {
    float: 'right',
    marginTop: 30,
  },
  listContent: {
    margin: get(margin, 'm0'),
  },
  pageBodyClass: {
    paddingTop: get(padding, 'p0'),
  },
  pageFilterAndSortClass: {
    marginTop: get(margin, 'm24'),
  },
});

export default styles;
